import React from 'react';
export function CarlosFinancieroLogo({
  size = 48
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0" data-id="element-60">
      {/* Background circle */}
      <circle cx="50" cy="50" r="50" fill="url(#gradientFinanciero)" data-id="element-61" />

      {/* Chart/Graph icon */}
      <path d="M30 65L40 50L50 55L60 40L70 45" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" data-id="element-62" />

      {/* Dollar sign */}
      <text x="50" y="35" fontSize="20" fontWeight="bold" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif" opacity="0.8" data-id="element-63">
        $
      </text>

      {/* Text "CM" */}
      <text x="50" y="85" fontSize="22" fontWeight="bold" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif" data-id="element-64">
        CM
      </text>

      {/* Gradient definition */}
      <defs data-id="element-65">
        <linearGradient id="gradientFinanciero" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-66">
          <stop offset="0%" stopColor="#3B82F6" data-id="element-67" />
          <stop offset="100%" stopColor="#1E40AF" data-id="element-68" />
        </linearGradient>
      </defs>
    </svg>;
}